"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useWaveData } from "@/hooks/useWaveData";
import useCapacitor from "@/hooks/useCapacitor";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import PrivilegedDropCreator, { DropMode } from "@/components/waves/PrivilegedDropCreator";
import { useApprovalWaveStatus } from "@/hooks/waves/useApprovalWaveStatus";
interface BrainContentInputProps {
  readonly activeDrop: ActiveDropState | null;
  readonly onCancelReplyQuote: () => void;
}
const BrainContentInput: React.FC<BrainContentInputProps> = t0 => {
  const $ = _c(15);
  const {
    activeDrop,
    onCancelReplyQuote
  } = t0;
  const capacitor = useCapacitor();
  const t1 = activeDrop?.drop.wave.id ?? null;
  let t2;
  if ($[0] !== onCancelReplyQuote) {
    t2 = () => onCancelReplyQuote();
    $[0] = onCancelReplyQuote;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      waveId: t1,
      onWaveNotFound: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: wave
  } = useWaveData(t3);
  const containerClassName = capacitor.isCapacitor ? "tw-max-h-[calc(100vh-14.7rem)]" : "tw-max-h-[calc(100vh-20rem)] lg:tw-max-h-[calc(100vh-20rem)]";
  let t4;
  if ($[5] !== wave) {
    t4 = {
      wave
    };
    $[5] = wave;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    isVotingControlsLocked
  } = useApprovalWaveStatus(t4);
  const fixedDropMode = isVotingControlsLocked ? DropMode.CHAT : DropMode.BOTH;
  if (!wave) {
    return null;
  }
  const t5 = `${containerClassName} tw-sticky tw-top-0 tw-z-30 tw-w-full tw-flex-none tw-overflow-y-auto tw-rounded-xl tw-bg-iron-950 tw-p-2 tw-shadow-lg tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-transition-colors tw-duration-500 tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 hover:tw-scrollbar-thumb-iron-300 md:tw-p-4`;
  let t6;
  if ($[7] !== activeDrop || $[8] !== fixedDropMode || $[9] !== onCancelReplyQuote || $[10] !== wave) {
    t6 = <PrivilegedDropCreator wave={wave} activeDrop={activeDrop} onCancelReplyQuote={onCancelReplyQuote} onAllDropsAdded={onCancelReplyQuote} onDropAddedToQueue={onCancelReplyQuote} key={wave.id} dropId={null} fixedDropMode={fixedDropMode} />;
    $[7] = activeDrop;
    $[8] = fixedDropMode;
    $[9] = onCancelReplyQuote;
    $[10] = wave;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default BrainContentInput;